import firebase from "../firebase";

const handleLogout = async () => {
  try {
    await firebase.auth().signOut();
  } catch (error) {
    console.log(error);
  }
};
export default handleLogout;
